module.exports = __webpack_public_path__ + "img/login_title1.01bc75e0.png";